module.exports = __webpack_public_path__ + "assets/img/bakcb.14be3e8b.png";